import { faqs } from '../data';

export default function Faq() {
  return (
    <div className="faq">
      {faqs.map((item) => (
        <details key={item.q} className="faq-item">
          <summary>{item.q}</summary>
          <p>{item.a}</p>
        </details>
      ))}
    </div>
  );
}
